import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk";

import utilitiesReducer from "../redux/utilities/slice"
import organizationReducer from "../redux/organization/slice"
import productReducer from "../redux/product/slice"
import propertyReducer from "../redux/property/slice"
import instrumentReducer from "../redux/instrument/slice"
import organizationUserReducer from "../redux/organizationUser/slice"
import dailyListReducer from "../redux/dailyList/slice"
import authReducer from "../redux/auth/slice"

// Combine all reducers
const rootReducer = combineReducers({
  utilities: utilitiesReducer,
  organization: organizationReducer,
  product: productReducer,
  property: propertyReducer,
  instrument: instrumentReducer,
  organizationUser: organizationUserReducer,
  dailyList: dailyListReducer,
  auth: authReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "utilities", "property"], // List of reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// store is configured with the persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(thunk),
});

// Create a persistor
export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
